/* globals define */
/*
  Purpose:
    - UI controller for the flyoutDIY on the L1 navigation list.

  Dependencies
    - Mustache
    - jQuery
    - Hoverintent
    - THD Namespace
*/
(function closure(root, factory) {
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    // eslint-disable-next-line max-len
    define('header.hsflyout', ['jquery', 'mustache', 'header.data', 'header.analytics', 'header.dropdownmodule', 'hoverIntent'],
      function load(jQuery, Mustache, headerData, headerAnalytics, headerDDFlyout) {
        return factory(root, jQuery, Mustache, headerData, headerAnalytics, headerDDFlyout);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.flyoutHS = factory(root, jQuery, Mustache, THD.HFApp.data, THD.HFApp.analytics, THD.HFApp.dropdownflyout, $.hoverIntent);
    /* eslint-enable */
  }
}(this, function factory(root, $, Mustache, headerData, headerAnalytics, headerDDFlyout) {
  let flyoutHS = {};
  let privateMethods = {};

  privateMethods.templates = {};

  privateMethods.templates.hslist = headerDDFlyout.templates.diyandhs;

  privateMethods.getFlyoutData = function getFlyoutData() {
    let jsonPath = '/hdus/en_US/DTCCOMNEW/fetch/hsflyout.json';
    let responseDataPromise = headerData.getEtchJSON(jsonPath);

    responseDataPromise.then(function _responseDataPromise(hsData) {
      let htmlContent = Mustache.render(privateMethods.templates.hslist, hsData.hsflyout);

      $('.hsFlyout').html(htmlContent);
    });
  };

  privateMethods.triggerHoverintent = function _triggerHoverIntent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this
    });
  };

  // bind to all the necessary elements
  privateMethods.initialize = function initialize() {
    if (headerData.isDropDown()) {
      // delegate to all the things
      $(document)
      // eslint-disable-next-line max-len
        .on('click touchend hoverintent', '.Header3 .ShoppingLinks__link[data-id="homeServices"]', privateMethods.getFlyoutData)
        .hoverIntent({
          selector: '.Header3 .ShoppingLinks__link[data-id="homeServices"]',
          over: privateMethods.triggerHoverintent,
          out: (function(){})
        });
      $(document)
        .on('click touchend', '#hsFlyout .content_image a', privateMethods.logInteractionforImg)
        .on('click touchend', '#hsFlyout .cta__text', privateMethods.logInteractionforL2)
        .on('click touchend', '#hsFlyout .diyFlyout__level3link', privateMethods.logInteractionforL3);
    }
  };

  privateMethods.logInteractionforL3 = function _logInteractionforL3() {
    let level2 = $(this).parents('.content').find('.cta__text').text();
    let level3 = $(this).text().toLowerCase();
    return privateMethods.logEventPath('header click', [level2, level3]);
  };

  privateMethods.logInteractionforL2 = function _logInteractionforL2() {
    let level2 = $(this).text().toLowerCase();
    return privateMethods.logEventPath('header click', [level2]);
  };

  privateMethods.logInteractionforImg = function _logInteractionforImg() {
    let level2 = $(this).attr('alt');
    return privateMethods.logEventPath('header click', [level2]);
  };

  privateMethods.logEventPath = function _logEventPath(type, pathArray) {
    // Get header at the beginning, then join them all
    let level1 = $('.Header3 .ShoppingLinks__link[data-id="homeServices"]').text();
    return headerAnalytics.logEvent(type, ['header', level1].concat(pathArray).join('>'));
  };

  /*
   * Public Methods
   */

  flyoutHS.init = function init() {
    privateMethods.initialize();
    headerData.init();

    return this;
  };

  flyoutHS.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  return flyoutHS;
}));
